import { useState } from "react";
import axios from "axios";

function AddDesignation({onClose}){

const [designationName,setDesignationName]=useState("");
const [description,setDescription]=useState("");

const saveDesignation=async(e)=>{

e.preventDefault();

try{

const token=
localStorage.getItem(
"token"
);

const response=
await axios.post(

"https://saleupcall.com/api/Designation/add-designation.php",

{
designation_name:designationName,
description
},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

alert(
"Designation Added"
);

setDesignationName("");
setDescription("");

if(onClose){

onClose();

}

}
else{

alert(
response.data.message
);

}

}
catch(error){

console.log(error);

}

};

return(

<form onSubmit={saveDesignation}>

<div className="row">

<div className="col-md-12 mb-2">

<input
type="text"
className="form-control form-control-sm"
placeholder="Designation Name"
value={designationName}
onChange={(e)=>
setDesignationName(
e.target.value
)
}
/>

</div>

<div className="col-md-12 mb-2">

<textarea
className="form-control form-control-sm"
rows="3"
placeholder="Description"
value={description}
onChange={(e)=>
setDescription(
e.target.value
)
}
/>

</div>

</div>

<div className="text-end mt-1">

<button
type="submit"
className="btn btn-primary btn-sm"
>

<i className="bi bi-check-lg me-1"></i>

Save Designation

</button>

</div>

</form>

);

}

export default AddDesignation;